import React from "react";

import { MainLayout } from "@/taskpane/layouts/MainLayout";

export const Home = () => {
  return <MainLayout headerTitle="Home">Home</MainLayout>;
};
